import $ from 'jquery';

export function track(eventName) {
  if (!eventName || typeof window.optimizely === 'undefined') {
    return false;
  }

  return window.optimizely.push({
    type: 'event',
    eventName,
  });
}

export function trackClicks() {
  $(document.body).on('click.optimizely', 'a[data-optimizely-event], button[data-optimizely-event]', (evt) => {
    track($(evt.currentTarget).data('optimizelyEvent'));
  });
}
